/**
 * Evaluates a predicate only in a browser context.
 *
 * Guards access to client-only globals (e.g. `window.location`) so that
 * module-level code stays safe when the package is imported by a
 * server-side-rendered consumer, where `window` is undefined.
 *
 * @param fn - Predicate that may read browser-only globals.
 * @param options - Optional overrides.
 * @param options.serverDefault - Value returned on the server instead of
 *   running `fn`. Defaults to `false`.
 * @returns The predicate's result in the browser; `serverDefault` on the server.
 */
export function clientOnlyCheck(fn: () => boolean, options?: { serverDefault?: boolean }): boolean {
  return typeof window !== 'undefined' ? fn() : (options?.serverDefault ?? false);
}
